import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  base: '.',
  mode: 'history',
  routes: [

    {
      path: '/',
      name: 'Home',
      component: () => import('@/components/views/001_Home'),
      meta: {
        title: '株式会社エーフォーワークス',
        description: '株式会社エーフォーワースク(A4 WORKS Inc.)のコーポレートサイトです。企業情報やサービス・案件事例紹介などをご紹介。'
      }
    },
    {
      path: '/information',
      name: 'Information',
      component: () => import('@/components/views/002_Information'),
      meta: {
        title: 'INFORMATION',
        description: '株式会社エーフォーワークス(A4 WORKS Inc.)からのお知らせ'
      }
    },
    {
      path: '/works',
      name: 'Works',
      component: () => import('@/components/views/003_Works'),
      meta: {
        title: 'WORKS',
        description: '株式会社エーフォーワークス(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介'
      }
    },
    {
      path: '/corporate',
      name: 'Corporate',
      component: () => import('@/components/views/004_Corporate'),
      meta: {
        title: '会社概要',
        description: '会社概要 - 株式会社エーフォーワークス(A4 WORKS Inc.) '
      }
    },
    {
      path: '/recruit',
      name: 'Recruit',
      component: () => import('@/components/views/005_Recruit'),
      meta: {
        title: 'RECRUIT',
        description: '採用情報 - 株式会社エーフォーワークス(A4 WORKS Inc.)'
      }
    },
    {
      path: '/privacypolicy',
      name: 'PrivacyPolicy',
      component: () => import('@/components/views/006_PrivacyPolicy'),
      meta: {
        title: 'プライバシーポリシー',
        description: 'プライバシーポリシー - 株式会社エーフォーワークス(A4 WORKS Inc.)'
      }
    },

    // -- Works -----------------------------------------------------

    {
      path: '/works/ses',
      name: 'WorksSES',
      component: () => import('@/components/views/works/Works_SES'),
      meta: {
        title: 'SES（システムエンジニアリングサービス）のご案内 - 事例紹介',
        description: 'SES（システムエンジニアリングサービス）のご案内。株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/remoteworklunch',
      name: 'WorksRemoteWorkLunch',
      component: () => import('@/components/views/works/Works_RemoteWorkLunch'),
      meta: {
        title: '「リモメシ」(Webサービス) - 事例紹介',
        description: '「リモメシ」リモートワークのランチを楽しむ。株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/kodomopay',
      name: 'WorksKodomopay',
      component: () => import('@/components/views/works/Works_kodomopay'),
      meta: {
        title: '「こどもペイ」(Webサービス) - 事例紹介',
        description: '「こどもペイ」はこども達の取り組みの見える化と取り組みの意欲を高めるアプリです。株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/calorina',
      name: 'WorksCalorina',
      component: () => import('@/components/views/works/Works_calorina'),
      meta: {
        title: 'カロリナ(iPhoneアプリ/Androidアプリ) - 事例紹介',
        description: 'あなたのダイエットをサポート！「カロリナ」は毎日記録して痩せるレコーディングダイエットアプリです。。株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/dogenzaka_kobou',
      name: 'WorksDogenzakaKobou',
      component: () => import('@/components/views/works/Works_dogenzakaKobou'),
      meta: {
        title: '「Fab Lounge 道玄坂工房」の空間プロデュース、コンサルティング業務 - 事例紹介',
        description: '「Fab Lounge 道玄坂工房」の空間プロデュース、コンサルティング業務。株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/ehonkan',
      name: 'WorksEhonkan',
      component: () => import('@/components/views/works/Works_ehonkan'),
      meta: {
        title: '森のえほん館(iOS,Androidアプリ) - 事例紹介',
        description: '「森のえほん館」は400冊以上の絵本が定額で読み放題！株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/hacot',
      name: 'WorksHacot',
      component: () => import('@/components/views/works/Works_hacot'),
      meta: {
        title: 'IoTデバイス hacot(はこっと)の開発支援業務',
        description: 'IoTデバイス hacot(はこっと)の開発支援。株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/pictbox',
      name: 'WorksPictbox',
      component: () => import('@/components/views/works/Works_pictbox'),
      meta: {
        title: 'Pictbox(Webサービス) - 事例紹介',
        description: '「Pictbox」はオリジナルの絵本・イラスト・スタンプ・マンガ・写真の投稿・閲覧が無料で楽しめ、オリジナルクリエイターをサポートするためのサービスです。株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/zs3',
      name: 'WorksZs3',
      component: () => import('@/components/views/works/Works_zs3'),
      meta: {
        title: '「ゼロヨンシフト3rd」(スマートフォン向けゲーム) - 事例紹介',
        description: 'スマートフォン向けゲーム「ゼロヨンシフト3rd」(ゼロヨンシフト サード)。株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/crepos',
      name: 'WorksCREPOS',
      component: () => import('@/components/views/works/Works_crepos'),
      meta: {
        title: 'CREPOS(Webサービス) - 事例紹介',
        description: '「CREPOS（クリポス）」は、クリエイターの”作る”を応援するサービスです。。株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },

    // -- Works  LineStamps-----------------------------------------------------

    {
      path: '/works/akari-chan',
      name: 'WorksAkari',
      component: () => import('@/components/views/works/Works_LS_akariChan'),
      meta: {
        title: 'とまとのあかりちゃん - LINE スタンプ ',
        description: 'とまとのあかりちゃんとその仲間たちのゆるゆるLINEスタンプ。。株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/chelsea',
      name: 'WorksChelsea',
      component: () => import('@/components/views/works/Works_LS_chelsea'),
      meta: {
        title: 'チェルシー＆ちびチェルシー - LINE スタンプ',
        description: 'チェルシーのドーナツ工場からチェルシー＆ちびチェルシー達がLINEスタンプに遊びに来たよ♪株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/haniwan',
      name: 'WorksHaniwan',
      component: () => import('@/components/views/works/Works_LS_haniwan'),
      meta: {
        title: 'はにわん - LINE スタンプ',
        description: 'はにわん♪がLINEスタンプに遊びに来たよ♪株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/im_here',
      name: 'WorksImHere',
      component: () => import('@/components/views/works/Works_LS_imHere'),
      meta: {
        title: '「いまここです〜」 - LINE スタンプ ',
        description: '「いまここです〜」のLINEスタンプ。株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/im_here2',
      name: 'WorksImHere2',
      component: () => import('@/components/views/works/Works_LS_imHere2'),
      meta: {
        title: '「いまここです〜 その２」 - LINE スタンプ',
        description: '「いまここです その２」のLINEスタンプ。株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/ishii_san',
      name: 'WorksIshiiSan',
      component: () => import('@/components/views/works/Works_LS_ishiiSan'),
      meta: {
        title: 'なにわの石井さん - LINE スタンプ',
        description: 'なにわの石井さんのLINEスタンプ。株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },
    {
      path: '/works/ride2victory',
      name: 'WorksRide2victory',
      component: () => import('@/components/views/works/Works_LS_ride2victory'),
      meta: {
        title: '打・蹴・投・極 - LINE スタンプ',
        description: '戦いの時は来た。必殺の一撃で沈めるのか!?華麗にコンボを決め撃砕するのか!?ライバルとの激戦を制し勝利を掴み取とるのはあなただ!｜株式会社エーフォーワースク(A4 WORKS Inc.)のサービス、プロジェクトの事例紹介。'
      }
    },

    // -- Error -----------------------------------------------------

    {
      path: '/404/',
      name: 'Error',
      component: () => import('@/components/views/ErrorMessage')
    },
    {
      path: '*',
      component: () => import('@/components/views/ErrorMessage')
    }

  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      // スクロールをトップに戻す
      return {x: 0, y: 0}
    }

  }
})



// WEBPACK FOOTER //
// ./src/modules/router/index.js